<script>
    import { botAvailableText } from './bot';
    import { unparsedCard } from './card_actions';
    import { res } from './stores'

    export let available;
    export let value;
    export let i;
    export let change;

    function organiseAvailable(){
        let sets = [];
        for(let s of $res.sets){
            let decks = [];
            for(let d of s.decks){
                if(available.includes(d)) decks.push(d);
            }
            if(decks.length > 0){
                sets.push({
                    label: s.name,
                    decks
                })
            }
        }
        return sets;
    }
</script>

<select bind:value={value} on:change={change}>
    {#each organiseAvailable(available) as s}
        <optgroup label={s.label}>
            {#each s.decks as c}
                <option value={c}>
                    {c}
                    {#if i != 0} {botAvailableText(c)} {/if}
                    {#if $res.cards.filter(cd => cd.deck == c).some(cd => unparsedCard(cd))}
                        - warning, {$res.cards.filter(cd => cd.deck == c && unparsedCard(cd)).length} cards don't parse yet
                    {/if}
                </option>
            {/each}
        </optgroup>
    {/each}
</select>